import { getTransitionFlags } from "../transition.js";
//#region src/core/ui/dialog/core.ts
var DialogCore = class {
	static defaultProps = {
		open: false,
		defaultOpen: false,
		closeOnEscape: true
	};
	#role;
	#input = null;
	#titleId = void 0;
	#descriptionId = void 0;
	#documentModal = true;
	constructor(role = "dialog") {
		this.#role = role;
	}
	/** Accept props for API consistency. Props are consumed by platform layers. */
	setProps(_props) {}
	setInput(input) {
		this.#input = input;
	}
	setTitleId(id) {
		this.#titleId = id;
	}
	setDescriptionId(id) {
		this.#descriptionId = id;
	}
	setDocumentModal(documentModal) {
		this.#documentModal = documentModal;
	}
	getState() {
		const input = this.#input;
		return {
			open: input.active,
			status: input.status,
			titleId: this.#titleId,
			descriptionId: this.#descriptionId,
			...getTransitionFlags(input.status)
		};
	}
	getTriggerAttrs(state, popupId) {
		return {
			"aria-expanded": state.open && state.status !== "ending" ? "true" : "false",
			"aria-haspopup": "dialog",
			"aria-controls": popupId
		};
	}
	getPopupAttrs(state) {
		return {
			role: this.#role,
			"aria-modal": this.#documentModal ? "true" : void 0,
			"aria-labelledby": state.titleId,
			"aria-describedby": state.descriptionId
		};
	}
};
//#endregion
export { DialogCore };

//# sourceMappingURL=core.js.map